<brightside-web-account-statements
  [accountId]="(currentAccountInfo$ | async)?.accountId"
  [statementType]="'taxes'"
></brightside-web-account-statements>
